module.exports = __webpack_public_path__ + "img/hyal-2.a02552c7.png";